import React from "react";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import { withStyles } from "tss-react/mui";
import vestigingStyle from "../../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import useVestigingRelation from "../../../components/Forms/useVestigingRelation";
import AuthProvider from "../../../auth/AuthProvider";
import CurrencyProvider from "../../../components/Forms/CurrencyProvider";
import VestigingProvider from "../../../components/Forms/VestigingProvider";
import JamezzFormV2 from "../../JamezzForm/JamezzFormV2";
import { formatTitle } from "../../../../utils/formatting";
import { Link } from "react-router";
import General from "./Tabs/General";

import { connect } from "react-redux";
import Products from "./Tabs/Products";
import { useSwitchToSalesarea } from "../../Vestigingen/UseSwitchToSalesarea";

const endPoint = "core/arrangementGroups";

function ArrangementGroupForm(props) {
  const { currency, menukaartVestigingId, vestiging, extraFields, onGetModel } = useVestigingRelation({
    vestiging_id: props.vestiging_id,
    routerMatch: props.match,
    history: props.history,
    endPoint,
  });

  useSwitchToSalesarea(vestiging);

  return (
    <AuthProvider prefix={"arrangementGroups"}>
      <CurrencyProvider currency={currency}>
        <VestigingProvider vestiging={vestiging}>
          <JamezzFormV2
            computedPageTitle={function (model) {
              return formatTitle(this.pageTitle, model.name);
            }}
            customFieldSerialization={{
              products: (products) =>
                JSON.stringify(products.map((product) => ({ id: product.id, pivot: product.pivot }))),
              menus: (menus) => JSON.stringify(menus),
            }}
            endPoint={endPoint}
            excludedKeysInOutput={{ raw_api_data: true }}
            extraFields={extraFields}
            extraFormProps={{ vestiging, vestigingId: vestiging?.id ?? props.vestiging_id, menukaartVestigingId }}
            mode={"onChange"}
            objectsExcludedAsRelation={{
              raw_api_data: true,
              products: true,
              menus: true,
            }}
            onGetModel={onGetModel}
            pageTitle={getTranslation("arrangementGroup.form.pageTitle", "Arrangement group")}
            pageTitleSubject={
              <small>
                <Link to={`/manager/vestigingen/${vestiging?.id}/edit`}>{vestiging?.naam}</Link> - {vestiging?.id}
              </small>
            }
            revalidateMode={"onChange"}
            rootRight={"arrangementGroups"}
            tabs={[
              {
                right: "general",
                tabButton: <TranslationWrapper tDefault={"General"} tKey={"arrangementGroup.form.tabs.general"} />,
                tabContent: <General />,
              },
              {
                right: "products",
                tabButton: <TranslationWrapper tDefault={"Products"} tKey={"arrangementGroup.form.tabs.products"} />,
                tabContent: <Products />,
              },
            ]}
          />
        </VestigingProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(withStyles(ArrangementGroupForm, vestigingStyle));
